import axios from "axios";
import { config } from '../config.env'

const platform = config.PLATFORM;
const endpoint = config.ENDPOINT;

export function appointmentAdd(form) {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/appointment/appoint`;
        const body = form;
        const header = {
            'Content-Type': 'application/json',
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };

        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function appointmentList(dateStart, dateEnd) {

    return new Promise(resolve => {

        let url = `${endpoint}/health-atm/appointment/appointmentlist?order=appointment_number&sort=desc`;
        if (dateStart)
            url += '&datestart='+dateStart;
        if (dateEnd)
            url += '&dateend='+dateEnd;

        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };

        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}